import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import SubmitButton from "../button/SubmitButton";
import CancelButton from "../button/CancelButton";

export default function ConfirmDialog({
  openDialog,
  handleCloseDialog,
  title,
  message,
  buttonLabel,
  isSubmitting,
  selectedIndex,
  handleSubmit
}) {
  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={isSubmitting}
      disableEscapeKeyDown={isSubmitting}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ margin: "20px" }}>
        <CancelButton onClick={handleCloseDialog} disabled={isSubmitting}>
          Cancel
        </CancelButton>
        <SubmitButton
          onClick={() => handleSubmit(selectedIndex)}
          disabled={isSubmitting}
          isSubmitting={isSubmitting}
        >
          {buttonLabel}
        </SubmitButton>
      </DialogActions>
    </Dialog>
  );
}
